<template>
  <div
    class="mb-3"
  >
    <div class="icon-text">
      <TickCircleSvg v-if="item.key" style="width: 20px"/>
      <CloseCircleSvg v-else style="width: 20px"/>
      <small :class="`${fontFamily} m-0`" v-html="$t(`prices.tableItems.${item.key}`)"></small>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import TickCircleSvg from '@/components/Icons/TickCircleSvg.vue';
import CloseCircleSvg from '@/components/Icons/CloseCircleSvg.vue';

export default defineComponent({
  components: {
    TickCircleSvg,
    CloseCircleSvg,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    fontFamily: {
      type: String,
      default: 'font-noto-r',
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
})
</script>

<style scoped>
.icon-text {
  display: grid;
  grid-template-columns: 30px auto;
}
</style>
